import { Skeleton } from "@mui/material";

const LeadsSkeleton = () => {
  return (
    <>
      <Skeleton variant="rounded" width={"100%"} height={60} sx={{ mb: 2 }} />
      <Skeleton variant="rounded" width={"100%"} height={60} sx={{ mb: 2 }} />
      <Skeleton variant="rounded" width={"100%"} height={60} sx={{ mb: 2 }} />
      <Skeleton variant="rounded" width={"100%"} height={60} sx={{ mb: 2 }} />
      <Skeleton variant="rounded" width={"100%"} height={60} sx={{ mb: 2 }} />
      <Skeleton variant="rounded" width={"100%"} height={60} sx={{ mb: 2 }} />
    </>
  );
};

export default LeadsSkeleton;
